import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@client/app/components/components.module';
import { TranslateModule } from '../modules/translate.module';
import { MonLabelsModule } from '@monsido/modules/labels/labels.module';
import { FormsModule } from '@angular/forms';
import { FormGlobalPolicyElementComponent } from '@client/app/forms/global-policy/steps/rules/boxes/element/element.component';
import { FormGlobalPolicySettingsComponent } from '@client/app/forms/global-policy/steps/rules/boxes/settings/settings.component';
import { FormGlobalPolicyBoxesComponent } from '@client/app/forms/global-policy/steps/rules/boxes/boxes.component';
import { FormGlobalPolicyRulesComponent } from '@client/app/forms/global-policy/steps/rules/rules.component';
import {
    NgbTooltipModule,
    NgbPaginationModule,
    NgbDropdownModule,
    NgbDatepickerModule, NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { UpgradePipeModule } from '../filters/upgrade-pipe.module';
import {
    FormBuilderInputModule, FormBuilderSelectModule, FormBuilderValidationModule,
    LayoutModule,
    MonDatePickerModule,
    MonEventTriggerModule, MonSelectAllCheckboxModule,
    MonSwitchModule,
    SelectNextAcComponent, TableSearchModule,
} from '@monsido/angular-shared-components';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { FormFeedbackComponent } from '@client/app/forms/feedback/feedback.component';
import { FormCustomerInfoComponent } from '@client/app/forms/customer-info/customer-info.component';
import { FormDomainExcludeIpComponent } from '@client/app/forms/domain-exclude-ip/domain-exclude-ip.component';
import { FormLabelComponent } from '@client/app/forms/label/label.component';
import { FormGlobalPolicyPreContentRuleMissingCompanyNameComponent } from '@client/app/forms/global-policy/steps/pre-content/rules/missing-company-name.component';
import { FormGlobalPolicyPreContentRuleMaxLengthComponent } from '@client/app/forms/global-policy/steps/pre-content/rules/max-word-length.component';
import { FormGlobalPolicyPreContentRuleWithoutContextComponent } from '@client/app/forms/global-policy/steps/pre-content/rules/without-context.component';
import { FormGlobalPolicyPreContentRuleRepeatedShortWordsComponent } from '@client/app/forms/global-policy/steps/pre-content/rules/repeated-short-words.component';
import { FormGlobalPolicyPreContentRuleMissingTrademarkComponent } from '@client/app/forms/global-policy/steps/pre-content/rules/missing-trademark.component';
import { FormGlobalPolicyExchangeCenterComponent } from '@client/app/forms/global-policy/steps/exchange-center/exchange-center.component';
import { FormGlobalPolicyContentComponent } from '@client/app/forms/global-policy/steps/content/content.component';
import { NgClickOutsideDelayOutsideDirective, NgClickOutsideDirective } from 'ng-click-outside2';
import { ValidateDomainDirective } from '@client/app/directives/validators/valid-domain.directive';
import { FormUserAccessComponent } from '@client/app/forms/user/steps/access/access.component';
import { FormUserBasicComponent } from '@client/app/forms/user/steps/basic/basic.component';
import { FormUserDomainsComponent } from '@client/app/forms/user/steps/domains/domains.component';
import { FormUserComponent } from '@client/app/forms/user/user.component';
import { OrderByModule } from '@client/ng2/shared/pipes/order-by/order-by.module';
import { FormGlobalPolicyDialogRuleCountRuleComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/count-rule/count-rule.component';
import { FormGlobalPolicyDialogRuleFileSizeComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/file-size/file-size.component';
import { FormGlobalPolicyDialogRuleImageSizeComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/image-size/image-size.component';
import { FormGlobalPolicyDialogRuleStandardComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/standard/form-global-policy-dialog-rule-standard.component';
import { FormGlobalPolicyDialogRuleReadabilityComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/readability/form-global-policy-dialog-rule-readability.component';
import { FormGlobalPolicyDialogRuleMetaHeaderLengthComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/meta-header-length/form-global-policy-dialog-rule-meta-header-length.component';
import { FormGlobalPolicyDialogRuleMetaHeaderComponent } from '@client/app/forms/global-policy/dialogs/rule/blocks/meta-header/form-global-policy-dialog-rule-meta-header.component';
import { FormGlobalPolicyDialogSaveComponent } from '@client/app/forms/global-policy/dialogs/save/save.component';
import { FormGlobalPolicyDialogRuleComponent } from '@client/app/forms/global-policy/dialogs/rule/rule.component';
import { PolicyExchangeCenterComponent } from '@client/app/modules/global-policy/exchange-center/exchange-center.component';
import { PolicyExchangeCenterViewsListComponent } from '@client/app/modules/global-policy/exchange-center/views/list/list.component';
import { PolicyExchangeCenterViewsGridComponent } from '@client/app/modules/global-policy/exchange-center/views/grid/grid.component';
import { PolicyExchangeCenterLabelsComponent } from '@client/app/modules/global-policy/exchange-center/label-selector-labels/label-selector-labels.component';
import { FormGlobalPolicyPreContentComponent } from '@client/app/forms/global-policy/steps/pre-content/form-global-policy-pre-content.component';
import { FormGlobalPolicyComponent } from '@client/app/forms/global-policy/form-global-policy.component';
import {
    DomainPickerComponent,
} from '@client/app/forms/global-policy/steps/rules/boxes/settings/domain-picker/domain-picker.component';
import { BaseLayoutModule } from '@layout/layout.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { FormPagePerformanceProfileComponent } from '@client/app/modules/page-performance/forms/profile/form-page-performance-profile.component';
import { FormPagePerformancePageComponent } from '@client/app/modules/page-performance/forms/page/form-page-performance-page.component';
import { PageFixFormDomainSettingsComponent } from '@client/app/modules/page-fix/forms/domain-settings/domain-settings.component';
import { FormUptimeScheduledDowntimeComponent } from '@client/app/forms/uptime/scheduled_downtimes/scheduled_downtime/scheduled_downtime.component';
import { FormUptimeScheduledDowntimesComponent } from '@client/app/forms/uptime/scheduled_downtimes/form-uptime-scheduled-downtimes.component';
import { UptimeComponent } from '@client/app/forms/uptime/uptime.component';
import { EmailTagsInputComponent } from '@client/app/forms/uptime/email-tags-input.component';
import { FormProfileComponent } from '@client/app/forms/profile/profile.component';
import { RemediationCompanionSectionComponent } from '@client/app/forms/profile/remediation-companion-section/remediation-companion-section.component';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';
import {
    FormDomainGroupsMatchRuleLabelComponent,
} from '@monsido/forms/domain/steps/domain-groups/steps/rules/match-rule/templates/label/label.component';
import { FormFieldDynamicComponent } from '@client/app/form-field-dynamic/form-field-dynamic.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        TranslateModule,
        MonLabelsModule,
        NgbTooltipModule,
        NgbPaginationModule,
        UpgradePipeModule,
        SelectNextAcComponent,
        MonDatePickerModule,
        MonActionMenuModule,
        MonEventTriggerModule,
        NgClickOutsideDirective,
        NgClickOutsideDelayOutsideDirective,
        LayoutModule,
        OrderByModule,
        DomainPickerComponent,
        BaseLayoutModule,
        ModalsDirectivesModule,
        NgbDropdownModule,
        ActiveFeaturePipe,
        TableSearchModule,
        FormBuilderInputModule,
        MonSelectAllCheckboxModule,
        NgbTimepickerModule,
        NgbDatepickerModule,
        FormBuilderSelectModule,
        FormBuilderValidationModule,
        MonSwitchModule,
        RemediationCompanionSectionComponent,
    ],
    declarations: [
        FormGlobalPolicyComponent,
        FormFeedbackComponent,
        FormCustomerInfoComponent,
        FormDomainExcludeIpComponent,
        ValidateDomainDirective,
        FormLabelComponent,
        FormUserAccessComponent,
        FormUserBasicComponent,
        FormUserDomainsComponent,
        FormUserComponent,
        FormGlobalPolicyDialogRuleCountRuleComponent,
        FormGlobalPolicyDialogRuleFileSizeComponent,
        FormGlobalPolicyDialogRuleImageSizeComponent,
        FormGlobalPolicyDialogRuleStandardComponent,
        FormGlobalPolicyDialogRuleReadabilityComponent,
        FormGlobalPolicyDialogRuleMetaHeaderLengthComponent,
        FormGlobalPolicyDialogRuleMetaHeaderComponent,
        FormGlobalPolicyDialogSaveComponent,
        FormGlobalPolicyDialogRuleComponent,
        FormGlobalPolicyPreContentRuleMissingCompanyNameComponent,
        FormGlobalPolicyPreContentRuleMaxLengthComponent,
        FormGlobalPolicyPreContentRuleWithoutContextComponent,
        FormGlobalPolicyPreContentRuleRepeatedShortWordsComponent,
        FormGlobalPolicyPreContentRuleMissingTrademarkComponent,
        FormGlobalPolicyExchangeCenterComponent,
        FormGlobalPolicyContentComponent,
        PolicyExchangeCenterComponent,
        PolicyExchangeCenterViewsListComponent,
        PolicyExchangeCenterViewsGridComponent,
        PolicyExchangeCenterLabelsComponent,
        FormGlobalPolicyPreContentComponent,
        FormGlobalPolicyElementComponent,
        FormGlobalPolicySettingsComponent,
        FormGlobalPolicyBoxesComponent,
        FormGlobalPolicyRulesComponent,
        FormPagePerformanceProfileComponent,
        FormPagePerformancePageComponent,
        PageFixFormDomainSettingsComponent,
        FormUptimeScheduledDowntimeComponent,
        FormUptimeScheduledDowntimesComponent,
        UptimeComponent,
        EmailTagsInputComponent,
        FormProfileComponent,
        FormDomainGroupsMatchRuleLabelComponent,
        FormFieldDynamicComponent,
    ],
    exports: [
        FormGlobalPolicyComponent,
        FormFeedbackComponent,
        FormCustomerInfoComponent,
        FormDomainExcludeIpComponent,
        ValidateDomainDirective,
        FormLabelComponent,
        FormUserAccessComponent,
        FormUserBasicComponent,
        FormUserDomainsComponent,
        FormUserComponent,
        FormGlobalPolicyDialogRuleCountRuleComponent,
        FormGlobalPolicyDialogRuleFileSizeComponent,
        FormGlobalPolicyDialogRuleImageSizeComponent,
        FormGlobalPolicyDialogRuleStandardComponent,
        FormGlobalPolicyDialogRuleReadabilityComponent,
        FormGlobalPolicyDialogRuleMetaHeaderLengthComponent,
        FormGlobalPolicyDialogRuleMetaHeaderComponent,
        FormGlobalPolicyDialogRuleComponent,
        FormGlobalPolicyPreContentRuleMissingCompanyNameComponent,
        FormGlobalPolicyPreContentRuleMaxLengthComponent,
        FormGlobalPolicyPreContentRuleWithoutContextComponent,
        FormGlobalPolicyPreContentRuleRepeatedShortWordsComponent,
        FormGlobalPolicyPreContentRuleMissingTrademarkComponent,
        FormGlobalPolicyExchangeCenterComponent,
        FormGlobalPolicyContentComponent,
        PolicyExchangeCenterComponent,
        PolicyExchangeCenterViewsListComponent,
        PolicyExchangeCenterViewsGridComponent,
        PolicyExchangeCenterLabelsComponent,
        FormGlobalPolicyPreContentComponent,
        FormGlobalPolicyElementComponent,
        FormGlobalPolicySettingsComponent,
        FormGlobalPolicyBoxesComponent,
        FormGlobalPolicyRulesComponent,
        FormPagePerformanceProfileComponent,
        FormPagePerformancePageComponent,
        PageFixFormDomainSettingsComponent,
        FormUptimeScheduledDowntimeComponent,
        FormUptimeScheduledDowntimesComponent,
        UptimeComponent,
        EmailTagsInputComponent,
        FormProfileComponent,
        FormDomainGroupsMatchRuleLabelComponent,
        FormFieldDynamicComponent,
    ],
})
export class UpgradeFormsModule {}
